import type { Dictionary } from "./en";

export const it: Partial<Dictionary> = {
  "lang.select": "Lingua",
  "lang.change": "Cambia lingua",

  "nav.hot": "Hot",
  "nav.categories": "Categorie",
  "nav.marketplace": "Marketplace",
  "nav.fund": "Finanzia",
  "nav.promote": "Promuovi",
  "nav.earn": "Guadagna",
  "nav.referrals": "Referral",
  "nav.soon": "Presto",
  "nav.login": "Accedi",
  "nav.dashboard": "Dashboard",
  "nav.getHot": "Diventa Hot",
  "nav.menu": "Menu",
  "nav.walletBalance": "Saldo Heat",
  "nav.home": "Home di BeHot.Now",
  "nav.profile": "Dashboard",
  "nav.messages": "Messaggi",
  "nav.logout": "Esci",
  "nav.balance": "Saldo",

  "footer.tagline": "Un unico posto per scoprire, assumere, vendere e promuovere. Entra in classifica. Diventa HOT. Fatti vedere.",
  "footer.howItWorks": "Come funziona",
  "footer.operatedBy": "Gestito da",
  "footer.disclosure":
    "Le posizioni a pagamento sono chiaramente indicate come tali. Prezzi mostrati in USD.",
  "footer.platform": "Piattaforma",
  "footer.comingSoon": "In arrivo",
  "footer.legal": "Legale",
  "footer.hotNow": "Hot ora",
  "footer.hotHistory": "Storico HOT",
  "footer.getHot": "Diventa Hot",
  "footer.referrals": "Referral",
  "footer.withdrawal": "Diritto di recesso",
  "footer.terms": "Termini di servizio",
  "footer.privacy": "Informativa sulla privacy",
  "footer.cookie": "Informativa sui cookie",
  "footer.rights": "Tutti i diritti riservati.",
  "footer.compareLeaderboards": "Confronta con altre classifiche",

  "home.h1.q": "Cos'è",
  "home.h1.a1": "È il posto dove",
  "home.h1.anything": "qualsiasi cosa",
  "home.h1.a2": "può competere per l'attenzione!",
  "home.sub1": "Sei un influencer, un personaggio pubblico o una celebrità?",
  "home.sub2":
    "Oppure hai una canzone, un live, un profilo, un brand, una startup, un'app, un prodotto, un'attività, un evento o anche solo un'idea?",
  "home.getItOnCharts": "Portalo in classifica",
  "home.now": "ora",
  "home.moreBoosts": "Più boost.",
  "home.higherRanking": "Posizione più alta.",
  "home.morePeople": "Più persone ti vedono.",
  "home.more": "Altro",
  "home.browseChart": "Sfoglia la classifica {label}",
  "home.listIt": "PUBBLICA",
  "home.boostIt": "BOOSTA",
  "home.climb": "SALI",
  "home.getSeen": "FATTI VEDERE",
  "home.howItWorks": "Come funziona",
  "home.generalBoard": "CLASSIFICA GENERALE",
  "home.podium.title": "Top 3 di ogni board",
  "home.podium.sub": "Il podio attuale di ogni board di categoria.",
  "home.generalBoardSub":
    "I migliori annunci di tutte le categorie, ordinati per Heat attivo totale.",
  "home.allBoards": "Tutte le classifiche",
  "home.loadingBoard": "Caricamento della classifica generale…",

  "lowHeat.title": "Stai finendo l'Heat",
  "lowHeat.body":
    "Stai finendo l'Heat: invita i tuoi amici e guadagna altro Heat, oppure ricarica subito il portafoglio.",
  "lowHeat.invite": "Invita amici",
  "lowHeat.topUp": "Ricarica portafoglio",
  "lowHeat.later": "Più tardi",

  "cookie.title": "Usiamo i cookie",
  "cookie.accept": "Accetta tutto",
  "cookie.reject": "Rifiuta i non essenziali",
  "cookie.settings": "Impostazioni cookie",
  "cookie.save": "Salva preferenze",

  "common.close": "Chiudi",
  "common.loading": "Caricamento…",
  "hiw.h1": "Come funziona BeHot.Now",
  "hiw.toc": "In questa pagina",
  "hiw.toc.title": "Indice",
  "hiw.toc.steps": "I cinque passaggi",
  "hiw.toc.rules": "Regole di classifica",
  "hiw.toc.entry": "Come funziona il prezzo d'ingresso",
  "hiw.toc.glossary": "Glossario",
  "hiw.toc.pricing": "Prezzi",
  "hiw.toc.faq": "FAQ",
  "hiw.toc.roadmap": "Cosa arriva presto",
  "hiw.toc.services": "Tutti i servizi",
  "hiw.toc.contact": "Contattaci",
  "hiw.steps.title": "I cinque passaggi",
  "hiw.ready.title": "Pronto a competere?",
  "hiw.ready.body": "Pubblica il tuo progetto o scopri cosa è di tendenza adesso.",
  "hiw.ready.list": "Pubblica ora",
  "hiw.ready.browse": "Sfoglia le classifiche",
  "hiw.rules.title": "Regole di classifica",
  "hiw.entry.title": "Come si calcola il prezzo d'ingresso in classifica",
  "hiw.entry.intro": "Entrare in una board è semplice, ma il prezzo è dinamico. Paghi sempre l'Heat attivo più basso della board più l'incremento della board. Questo esempio mostra esattamente come funziona.",
  "hiw.entry.lowest": "Heat attivo più basso attuale nella board",
  "hiw.entry.plus": "+ incremento",
  "hiw.entry.increment": "Incremento della board",
  "hiw.entry.min": "Il tuo costo minimo d'ingresso",
  "hiw.entry.note": "Se la board è vuota o appena resettata, il costo d'ingresso è l'offerta di apertura — di solito 3 Heat — così i primi entrano a poco prima che la gara si scaldi.",
  "hiw.heat": "{n} Heat",
  "hiw.glossary.title": "Glossario",
  "hiw.pricing.title": "Prezzi",
  "hiw.pricing.oneHeat": "Prezzo di 1 Heat",
  "hiw.pricing.oneHeatNote": "Pagamento una tantum · nessun abbonamento",
  "hiw.pricing.listing": "Prezzo di pubblicazione",
  "hiw.pricing.listingNote": "Per pubblicare il tuo progetto in una board",
  "hiw.pricing.entry": "Ingresso in board",
  "hiw.pricing.entryValue": "Heat più basso + incremento",
  "hiw.pricing.entryNote": "Esempio: 12 Heat + 1 = 13 Heat per entrare",
  "hiw.pricing.opening": "Offerta di apertura",
  "hiw.pricing.openingNote": "Costo d'ingresso in una board nuova o vuota",
  "hiw.faq.title": "Domande frequenti",
  "hiw.roadmap.title": "Cosa arriva presto",
  "hiw.soon": "Prossimamente",
  "hiw.promote.body": "Acquista azioni promozionali reali dai creator: post, storie, shoutout e collab, a prezzi fissi con deposito in garanzia e prova di consegna.",
  "hiw.promote.more": "Scopri di più su Promote",
  "hiw.earn.body": "I creator pubblicano il loro listino, ricevono richieste dirette, consegnano con prova e prelevano i guadagni in USD.",
  "hiw.earn.more": "Scopri di più su Earn",
  "hiw.services.title": "Tutti i servizi, spiegati",
  "hiw.services.intro": "BeHot.Now è molto più della board. Ecco tutto ciò che la piattaforma fa oggi e tutto ciò che sta arrivando.",
  "hiw.services.open": "Apri {name}",
  "hiw.contact.title": "Parla con noi",
  "hiw.contact.intro": "Scegli il servizio a cui si riferisce la tua richiesta — inclusi Supporto e Vendite — e la inoltreremo al team giusto.",
  "hiw.cta.title": "Pronto per la posizione 01?",
  "hiw.cta.button": "Entra in una board",
  "stats.liveUsers": "{n} utenti live",
  "stats.totalVisits": "{n} visite totali",
};
